export const SERVICE_CODE = 'TRAINING' + '_SERVICE';
